import { Props as ImportedProps } from './Background';
export { default } from './Background';
export type Props = ImportedProps;
